import { render } from "./JsonEditor.vue?vue&type=template&id=551b7776"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"
script.render = render

export default script